import React, { memo, FC } from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { createPortal } from 'react-dom';

// const Container = styled.div`
//   position: fixed;
//   bottom: 0;
//   width: 100%;
//   z-index: 2;
//   border-top: 1px solid #eeeeee;
//   background-color: white;
//   transform: translate(0, 100%);

//   &.is-ready {
//     animation: slide-in;
//     animation-fill-mode: both;
//     animation-duration: 0.66s;
//     animation-timing-function: ease-out;
//   }

//   @keyframes slide-in {
//     from {
//       transform: translate(0, 100%);
//     }

//     to {
//       transform: translate(0, 0);
//     }
//   }
// `;

const ContainerStyle = css`
  &.is-ready {
    animation: slide-in;
    animation-fill-mode: both;
    animation-duration: 0.66s;
    animation-timing-function: ease-out;
  }

  @keyframes slide-in {
    from {
      transform: translate(0, 100%);
    }

    to {
      transform: translate(0, 0);
    }
  }
`;

interface SpacerPortalProps {
  height: string;
}

const SpacerPortal: FC<SpacerPortalProps> = (props) => {
  const { height } = props;
  // createPortal is used to add a fixed-height bit of extra space at the bottom of the page.
  // This is necessary for the bar since it has `position: fixed;` and is removed from document flow.
  // As a result, without this shim portal we will cover content in the footer of the page.
  return typeof document !== 'undefined'
    ? createPortal(<div style={{ height: height, width: '100%' }} />, document.body)
    : null;
};

interface StickyContainerProps {
  className?: string;
  height: string;
  isReady: boolean;
  children: any;
}

// Ensure that the sticky container will display if the isReady contract isn't kept...
const StickyContainer: FC<StickyContainerProps> = ({
  children,
  className,
  height,
  isReady = true,
}) => (
  <div
    className={cn(
      className,
      ContainerStyle,
      'fixed bottom-0 w-full inset-x-0 z-10 border-t border-dove bg-white',
      { 'is-ready': isReady }
    )}
  >
    {children}
    <SpacerPortal height={height} />
  </div>
);

export default memo(StickyContainer);
